import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=cf1da8ce&scoped=true&lang=pug&"
import script from "./scripts/Home.js?vue&type=script&lang=js&"
export * from "./scripts/Home.js?vue&type=script&lang=js&"
import style0 from "./Home.vue?vue&type=style&index=0&id=cf1da8ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1da8ce",
  null
  
)

export default component.exports